const sideNavMessages = {
  en: {
    // get the labels for our side menu
    tasks: 'Tasks',
    tasksV2: 'Tasks v2',
    maintenanceTasks: 'Maintenance Tasks',
    inventory: 'Inventory',
    analytics: 'Analytics',
    analyticsOverview: 'Overview',
    analyticsOperations: 'Operations',
    analyticsMemberships: 'Memberships',
    analyticsWindow: 'Window',
    analyticsFinancial: 'Financial',
    expenses: 'Expenses',
    team: 'Team',
    washCounts: 'Wash Counts',
    detergents: 'Detergents',
    rewash: 'Rewashes',
    claims: 'Claims',
    claimsOld: 'Claims',
    claimsV2: 'Claims v2',
    expenses: 'Expenses',
    home: 'Home',
    settings: 'Settings',
    reports: 'Reports',
    admin: 'Admin',
    projects: 'Projects',
    workOrders: 'Work Orders',
    assets: 'Assets',
    myAssets: 'My Assets',
    siteAssets: 'Asset Catalog',
  },
};

export default sideNavMessages;
